import { render } from "./MvMap.vue?vue&type=template&id=70dc0cde"
import script from "./MvMap.vue?vue&type=script&lang=js"
export * from "./MvMap.vue?vue&type=script&lang=js"

import exportComponent from "F:\\-=Projects=-\\Sites\\map\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__